document.addEventListener("keydown", function (e) {
  /*
      CTRL + K : Focus on the user search
      Keycode 75
  */
  if(e.ctrlKey && e.which == 75) {
    document.querySelector('hubl-search-users > input').focus();
    e.preventDefault();
  }
});